import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import { RepairVacanciesResponse, VacancySyncState } from "./types";

import { decodeSlug } from "@/features/integrations/utils/slug";
import { instance } from "@/lib/axios/instance";
import useToast from "@/lib/hooks/useToast";

type ProblemDetails = {
  detail?: string;
  title?: string;
  status?: number;
  error?: string;
  code?: string;
};

export function useRepairVacancies({
  integrationName,
}: {
  integrationName: string;
}) {
  const { showToast } = useToast();
  const { t } = useTranslation();

  return useMutation<
    RepairVacanciesResponse,
    AxiosError<ProblemDetails>,
    { clientId: string; syncState?: VacancySyncState | null }
  >({
    mutationFn: ({ clientId, syncState }) => {
      const body: Record<string, string> = {};
      if (syncState !== null && syncState !== undefined) {
        body.syncState = String(syncState);
      }
      return instance
        .post<RepairVacanciesResponse>(
          `/api/v2/Integrations/${integrationName}/job-sync/Vacancies/Repair?clientId=${clientId}`,
          body
        )
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      showToast(data.message, "success");
    },
    onError: (error) => {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.detail ||
        t(`integrations.modules.names.${decodeSlug(integrationName)}`);
      showToast(errorMessage, "error");
    },
  });
}
